import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styles from './IntegrationTile.module.scss';

/**
 * Generic integration tile for the /integrations listing page.
 * All per-integration tiles (SageHR, ZohoPeople, …) use this.
 */
export const IntegrationTile = ({
  name,
  description,
  logoText,
  logoColor,
  route,
  subscribeToStatus,
}) => {
  const companyId = useSelector(
    (s) => s.auth.profile?.activeCompany?.companyId
  );
  const history = useHistory();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    return subscribeToStatus(companyId, (status) =>
      setConnected(status.connected)
    );
  }, [companyId, subscribeToStatus]);

  return (
    <div
      className={styles.tile}
      onClick={() => history.push(route)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && history.push(route)}
    >
      <div className={styles.logo} style={{ background: logoColor }}>
        {logoText}
      </div>
      <div className={styles.body}>
        <div className={styles.titleRow}>
          <span className={styles.name}>{name}</span>
          <span
            className={`${styles.badge} ${connected ? styles.connected : styles.disconnected}`}
          >
            {connected ? 'Connected' : 'Not Connected'}
          </span>
        </div>
        <p className={styles.description}>{description}</p>
      </div>
      <div className={styles.arrow}>›</div>
    </div>
  );
};
